var analyticsModule;
/**
 * Analytics is lazy-required since it is web-compliant only and all js-auth-tools middlewares get required by both web and native where
 * which this module is incompatible with
 */

export var getAnalytics = function getAnalytics() {
  if (!analyticsModule) {
    // eslint-disable-next-line global-require
    analyticsModule = require('@nerdwallet/analytics')["default"];
  }

  return analyticsModule;
};